import { useEffect } from 'react'

import { Input, LoaderCircle } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import { useNewPolicyContext } from '@/modules/ecom-policy/new/index.context'
import queries from '@/modules/ecom-policy/queries'
import { ecomPolicyResources } from '@/modules/ecom-policy/resources'

const StepName = () => {
  const newPolicy = useNewPolicyContext()
  const [descriptionInfo, setDescriptionInfo] = newPolicy.descriptionInfo
  const [name, setName] = newPolicy.selectedName

  const translate = useTranslation()
  const [selectedClassifications] = useNewPolicyContext().selectedClassifications
  const { data: classifications, isLoading } = useQuery(
    queries.categoryClassification(),
    ecomPolicyResources.getCategoryClassification
  )
  if (isLoading || !classifications) {
    return <LoaderCircle />
  }

  useEffect(() => {
    if (descriptionInfo.isCustom) return

    const noClassificationsSelected =
      !selectedClassifications || selectedClassifications.length === 0

    // To reset the previously generated desc for a scenario of resigning from the classifications in the process
    if (descriptionInfo.description && noClassificationsSelected) {
      setDescriptionInfo({
        isCustom: false,
        description: '',
      })

      return
    }

    if (noClassificationsSelected) return

    const isAllChoice = selectedClassifications.length === classifications.length

    const classificationList = selectedClassifications.map(selectedClassification => {
      const label = classifications.find(
        classification => classification.id === selectedClassification
      )?.name

      return label ? translate(label) : ''
    })

    setDescriptionInfo({
      isCustom: false,
      description: isAllChoice ? translate('All products') : classificationList.join(', '),
    })
  }, [
    classifications,
    descriptionInfo.description,
    descriptionInfo.isCustom,
    selectedClassifications,
    setDescriptionInfo,
    translate,
  ])

  return (
    <div className="xxs:flex-wrap flex md:flex-nowrap">
      <div className="m-2">
        <Input
          id="name"
          value={name}
          label={<Translation id="Policy name" />}
          onChange={e => setName(e.target.value)}
        />
      </div>

      <div className="m-2">
        <Input
          className="sm:w-80 lg:w-[35rem] 2xl:w-[62rem]"
          id="description"
          value={descriptionInfo.description}
          label={<Translation id="Description" />}
          onChange={e => setDescriptionInfo({ description: e.target.value, isCustom: true })}
        />
      </div>
    </div>
  )
}

export default StepName
